import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAttempt, getAttributeData, getIsDcuiProcessCompleted, getVerificationFormState } from "@redux/selectors/verification-form-selectors";
import { checkIsAsyncComplete, checkIsOOBComplete } from "@utils/verification-form-util";
import {
    disableAsyncButton,
    disableSubmitButton,
    setAsyncButtonText,
    setAsyncCompleted,
    setShowAsyncButton
} from "@redux/actions/verification-form-actions";
import { Logger } from "@utils/logger";
import { setShouldUpdateSubmitButton } from "@redux/actions/common-actions";
import { getShouldUpdateSubmitButton } from "@redux/selectors/common-selectors";
import { Dispatch } from "redux";
import { getDoDCUI } from "@redux/selectors/verification-configuration-selectors";


export const useUpdateSubmitButtonState = () => {
    const dispatch = useDispatch();
    const verificationFormState = useSelector(getVerificationFormState);
    const attempt = useSelector(getAttempt);
    const attributeDataState = useSelector(getAttributeData);
    const shouldUpdateSubmitButton = useSelector(getShouldUpdateSubmitButton);
    const shouldGoToDcui = useSelector(getDoDCUI);
    const isDcuiProcessCompleted = useSelector(getIsDcuiProcessCompleted);

    const showAsyncButtonHelper = (dispatch: Dispatch) => (attempt: number) => {
        if (attempt > 0) {
            dispatch(setAsyncButtonText('common.button.asyncRetry'));
        }
        dispatch(setShowAsyncButton(true));
    }

    const updateSubmitButtonState = () => {
        const isOOBComplete = checkIsOOBComplete(attributeDataState);
        const isAsyncComplete = checkIsAsyncComplete(attributeDataState, shouldGoToDcui, isDcuiProcessCompleted);
        
      
        dispatch(setShouldUpdateSubmitButton(false));
        Logger.info('[inspectAsyncAttributesStatus] isAsync is complete', isAsyncComplete);
        Logger.info('[inspectAsyncAttributesStatus] OOB is complete', isOOBComplete);
    
        //disable buttons at start
        dispatch(disableSubmitButton(true));
        dispatch(disableAsyncButton(true));
    
        //if both true, set async completed and show submit button
        if (isAsyncComplete && isOOBComplete) {
            dispatch(setAsyncCompleted(true));
            dispatch(setShowAsyncButton(false));
            dispatch(disableSubmitButton(false));
        } 
        //if only async complete, set async completed true
        else if (isAsyncComplete) {
            dispatch(setAsyncCompleted(true));
        }
        //if only oob complete, show and enable the async button
        else if (isOOBComplete) {
            dispatch(setAsyncCompleted(false));
            showAsyncButtonHelper(dispatch)(attempt);
            dispatch(disableAsyncButton(false));
        }
        //if both false, just show the async button
        else {
            showAsyncButtonHelper(dispatch)(attempt);
        }
    }

    useEffect(() => {
        if (verificationFormState.initialized && shouldUpdateSubmitButton) {
            updateSubmitButtonState();
        }
    }, [verificationFormState.initialized, shouldUpdateSubmitButton]);
};